import React from 'react';
import MenuView from './MenuView';
import TaskMenu from '../../ws/TaskMenu';
import { Center } from '../../model/domain/center';
import { CustomResponse } from '../../model/data/common';
import { CenterManager } from '@cuatroochenta/co-admin-react-library';

export interface ResponseGetMenu {
    pdfBytes: Uint8Array | null
    success: boolean
    message: string | null
    error: string | null
}

export interface ResponseUpdateMenu {
    success: boolean
    message: string | null
    error: string | null
}

export interface MenuUser {
    success: boolean;
    code: number;
    data: {
        roles: number[]
    };
}

interface State {
    getMenuResponse: ResponseGetMenu | null
    updateMenuResponse: ResponseUpdateMenu | null
    user: MenuUser | null,
    centers: Center[] | null
}

class MenuContainer extends React.Component {

    public state: State = {
        getMenuResponse: null,
        updateMenuResponse: null,
        user: null,
        centers: null
    };

    public getUser() {
        return new TaskMenu().getUser()
            .then(async (user: MenuUser) => {
                this.setState({ user });
                const centerId = CenterManager.getSelectedCenter();
                if (centerId) {
                    await this.getMenu(parseInt(centerId));
                } else {
                    console.log('No se encontró centerId en localStorage');
                }
            });
    }

    public getCenters() {
        return new TaskMenu().getCenters()
            .then((response: CustomResponse<Center[]>) => {
                this.setState({ centers: response.data });
            });
    }

    public getMenu(centerId: number | undefined) {
        return new TaskMenu().getMenu(centerId)
            .catch(
                (response) => {
                    this.setState({getMenuResponse: {success:false, error: response.message} as ResponseGetMenu});
                }
            )
            .then(
                (response) => {
                    if (response instanceof Uint8Array) {
                        this.setState({
                            getMenuResponse: {
                                pdfBytes: response
                            }
                        });
                    } else {
                        this.setState({ getMenuResponse: response });
                    }
                }
            )
    }

    public updateMenu(centerId: number | undefined, file: File) {
        return new TaskMenu().updateMenu(centerId, file)
            .catch(
                (response) => {
                    this.setState({updateMenuResponse: {success:false, error: response.message} as ResponseGetMenu});
                }
            )
            .then(
                (response) => {
                    if (response !== undefined) {
                        this.setState({updateMenuResponse: response});
                    }
                }
            )
    }

    public resetMenu() {
        this.setState({ getMenuResponse: null });
    }

    public render() {
        return <MenuView
            getMenu={this.getMenu.bind(this)}
            getUser={this.getUser.bind(this)}
            getCenters={this.getCenters.bind(this)}
            updateMenu={this.updateMenu.bind(this)}
            resetMenu={this.resetMenu.bind(this)}
            getMenuResponse={this.state.getMenuResponse}
            updateMenuResponse={this.state.updateMenuResponse}
            user={this.state.user}
            centers={this.state.centers}
        />;
    }

}

export default MenuContainer;